module.exports = __webpack_public_path__ + "img/logo-mst.4fe3d527.png";